// extracted by mini-css-extract-plugin
export var contents = "BaseUpsellModal-module__contents___x2G0Y";
export var heading = "BaseUpsellModal-module__heading___rjUq0";
export var logo = "BaseUpsellModal-module__logo___GMfyD";